export const PL = 'PL'
export const TCP = 'TCP'
export const JWT = 'JWT'

export const GENERAL = 'general'
export const EXTERNAL = 'external'
